import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { listNotificationTemplates, saveNotificationTemplate } from "../../../../services/platform_admin_service";

const usePlatformNotifications = () => {
    const [templates, setTemplates] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    const selected = templates.find(t => t.id === selectedId) || templates[0] || null;

    const fetchTemplates = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await listNotificationTemplates();
            const list = result.items || [];
            setTemplates(list);
            if (!selectedId && list.length > 0) setSelectedId(list[0].id);
        } catch (err) {
            console.error("[usePlatformNotifications]", err);
            setError(err.message || "Erro ao carregar modelos.");
        } finally {
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchTemplates();
    }, [fetchTemplates]);

    const saveTemplate = async (templateData) => {
        try {
            setSaving(true);
            setError(null);
            await saveNotificationTemplate(templateData);
            await fetchTemplates();
            setSuccessMessage("Modelo de mensagem salvo com sucesso!");
            setTimeout(() => setSuccessMessage(null), 3000);
            toast.success("Modelo de mensagem salvo com sucesso!");
        } catch (err) {
            const msg = err.message || "Erro ao salvar modelo.";
            setError(msg);
            toast.error(msg);
            throw err;
        } finally {
            setSaving(false);
        }
    };

    const toggleActive = async (id) => {
        const template = templates.find(t => t.id === id);
        if (!template) return;
        await saveTemplate({ ...template, active: !template.active });
    };

    return {
        templates,
        selected,
        selectedId,
        loading,
        saving,
        error,
        successMessage,
        setSelectedId,
        saveTemplate,
        toggleActive,
    };
};

export default usePlatformNotifications;
